<template>
  <div class="bankAccountList">
    <!-- 搜索 -->
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <!-- 表格 -->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width || 120"
          :sortable="item.sortable"
          :field="item.field"
          :formatter="item.formatter"
          :params="item.params"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <!--批量上传 -->
    <SiruiUpload ref="siruiUpload" @getData="getData" :action="action" :data="importData" />
  </div>
</template>

<script>
  import tableMixins from '@/common/mixins/table.js';
  import API from '@/api/financeCenter/bankAccount';
  // import BASE_API from '@/api/dataBase.js';
  import SiruiUpload from '@/components/SiruiUpload';
  import XEUtils from 'xe-utils';
  export default {
    components: {
      SiruiUpload,
    },
    name: 'bankAccountList',
    mixins: [tableMixins],
    computed: {
      //上传地址
      action() {
        return API.IMPORT_BANKACCOUNT;
      },
      //导入额外参数
      importData() {
        return {
          tenantCode: this.userInfo.userInfo.tenantCode,
          companyCode: this.userInfo.userInfo.companyCode,
          companyName: this.userInfo.userInfo.companyName,
          departmentCode: this.userInfo.userInfo.departmentCode,
          departmentName: this.userInfo.userInfo.departmentName,
          belongTenantCode: this.userInfo.userInfo.tenantCode,
          dataGroup: this.$globalVar.dataGroup,
          access_token: this.userInfo.userInfo.access_token,
        };
      },
      searchColumns() {
        return [
          {
            // 公司
            name: this.$t('bankAccountList.search.company'),
            prop: 'companyCode',
            type: 'select',
            options: this.companyList,
            changeMethod: 'changeCompany',
            filterable: true,
          },
          {
            // 银行国家
            name: this.$t('bankAccountList.search.bankNational'),
            prop: 'bankNational',
            type: 'dict',
            dictType: 'person_national',
          },
          {
            // 银行名称
            name: this.$t('bankAccountList.search.bankName'),
            prop: 'bankName',
            type: 'input',
          },
          {
            // 银行代码
            name: this.$t('bankAccountList.search.bankCode'),
            prop: 'bankCode',
            type: 'input',
          },
          {
            // 分行
            name: '分行',
            prop: 'branchName',
            type: 'input',
          },
          {
            // 默认账户
            name: '默认账户',
            prop: 'isDefault',
            type: 'dict',
            dictType: 'isAnotherPay',
          },
          {
            // 银行账户
            name: this.$t('bankAccountList.search.bankAccountName'),
            prop: 'bankAccountName',
            type: 'input',
          },
          /* {
          // 账户描述
          name: this.$t('bankAccountList.search.bankAccountDesc'), 
          prop: "bankAccountDesc", 
          type: "input",
        }, */
          {
            // 银行账号
            name: this.$t('bankAccountList.search.bankAccountNum'),
            prop: 'bankAccountNum',
            type: 'input',
          },
          {
            // 账户属性
            name: this.$t('bankAccountList.search.classCode'),
            prop: 'classCode',
            type: 'dict',
            dictType: 'bankClassCode',
          },
          {
            // 帐户二级属性
            name: this.$t('bankAccountList.search.secondaryClassCode'),
            prop: 'secondaryClassCode',
            type: 'dict',
            dictType: 'bankClassCode-2',
          },
          {
            // 总账科目
            prop: 'generalLedgerAccount',
            name: this.$t('bankAccountList.search.generalLedgerAccount'),
            type: 'searchTableSpec',
            searchType: 'account',
            isMultiple: true,
          },
          // { // 总账科目 缺少接口
          //   name: this.$t('bankAccountList.search.generalLedgerAccount'),
          //   prop: "generalLedgerAccount",
          //   type: "dict",
          //   dictType: 'generalLedgerAccount'
          // },
          {
            // 账户状态
            name: this.$t('bankAccountList.search.bankAccountStatus'),
            prop: 'bankAccountStatus',
            type: 'dict',
            dictType: 'bankAccountStatus',
          },
          {
            // 创建日期从
            name: this.$t('bankAccountList.search.gmtCreateStart'),
            prop: 'gmtCreateStart',
            type: 'startDaterangePicker',
          },
          {
            // 创建日期到
            name: this.$t('bankAccountList.search.gmtCreateEnd'),
            prop: 'gmtCreateEnd',
            type: 'endDaterangePicker',
          },
        ];
      },
    },
    data() {
      return {
        exportAction: API.EXPORT_BANKACCOUNT,
        companyList: [],
        query: {
          companyCode: null,
          bankNational: null,
          bankName: null,
          bankCode: null,
          branchName: null,
          isDefault: null,
          bankAccountName: null,
          bankAccountDesc: null,
          bankAccountNum: null,
          classCode: null,
          secondaryClassCode: null,
          generalLedgerAccount: null,
          bankAccountStatus: null,
          gmtCreateStart: null,
          gmtCreateEnd: null,
        },
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            field: 'companyCode',
            title: 'bankAccountList.table.companyCode',
            visible: true,
          },
          {
            field: 'companyName',
            title: 'bankAccountList.table.companyName',
            visible: true,
          },

          {
            field: 'bankCode',
            title: 'bankAccountList.table.bankCode',
            visible: true,
          },
          {
            field: 'bankName',
            title: 'bankAccountList.table.bankName',
            visible: true,
          },
          {
            field: 'branchName',
            title: 'bankAccountList.table.branchName',
            visible: true,
          },
          {
            field: 'branchCode',
            title: 'bankAccountList.table.branchCode',
            visible: true,
          },
          {
            field: 'bankConnectionFlag',
            title: 'bankAccountList.table.bankConnectionFlag',
            visible: true,
            dictType: 'yes-no',
          },
          {
            field: 'bankAccountName',
            title: 'bankAccountList.table.bankAccountName',
            visible: true,
          },
          {
            field: 'bankAccountNum',
            title: 'bankAccountList.table.bankAccountNum',
            visible: true,
          },
          {
            field: 'bankAccountDesc',
            title: 'bankAccountList.table.bankAccountDesc',
            visible: true,
          },
          {
            field: 'sapBankAccountCode',
            title: 'bankAccountEdit.bankForm.sapBankAccountCode',
            visible: true,
          },
          {
            field: 'sapBankCode',
            title: 'bankAccountEdit.bankForm.sapBankCode',
            visible: true,
          },
          {
            field: 'isDefault',
            title: 'bankAccountList.table.isDefault',
            visible: true,
            dictType: 'externalCustomerCode',
          },
          {
            field: 'classCode',
            title: 'bankAccountList.table.classCode',
            visible: true,
            dictType: 'bankClassCode',
          },
          {
            field: 'secondaryClassCode',
            title: 'bankAccountList.table.secondaryClassCode',
            visible: true,
            dictType: 'bankClassCode-2',
          },
          {
            field: 'currencyCode',
            title: 'bankAccountList.table.currencyCode',
            visible: true,
            dictType: 'all_currency',
          },
          {
            field: 'generalLedgerAccount',
            title: 'bankAccountList.table.generalLedgerAccount',
            visible: true,
          },
          {
            field: 'createUser',
            title: 'bankAccountList.table.createBy',
            visible: true,
          },
          {
            field: 'gmtCreate',
            title: 'bankAccountList.table.gmtCreate',
            visible: true,
          },
          {
            field: 'updateUser',
            title: 'bankAccountList.table.lastModifiedBy',
            visible: true,
          },
          {
            field: 'gmtModified',
            title: 'bankAccountList.table.gmtModified',
            visible: true,
          },
          {
            field: 'bankAccountStatus',
            title: 'bankAccountList.table.bankAccountStatus',
            visible: true,
            dictType: 'bankAccountStatus',
            fixed: 'right',
          },
        ],
      };
    },
    mounted() {
      this.getCompany();
      this.getData();
      this.getButtonList();
    },
    methods: {
      async getCompany() {
        // 公司
        let res = await this.$baseRequest.getCompanyList();
        if (res) {
          this.companyList = res;
        }
      },
      getData() {
        this.load = true;
        let query = Object.assign({}, this.query);
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        let params = { ...query, pageNum, pageSize };
        if (params.gmtCreateStart) params.gmtCreateStart = params.gmtCreateStart + ' 00:00:00';
        if (params.gmtCreateEnd) params.gmtCreateEnd = params.gmtCreateEnd + ' 23:59:59';
        if (XEUtils.isArray(params.generalLedgerAccount))
          params.generalLedgerAccount = params.generalLedgerAccount[0].accountCode;
        this.$axios.post(API.QUERY_BANKACCOUNT_PAGE, params).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          }
        });
      },
      chooseClick(value) {
        if (value == 'add') {
          this.toPath('bankAccountAdd', {});
        } else if (value == 'edit') {
          if (this.multipleSelection.length != 1) {
            return this.tips('onlyOneSelectData', 'error');
          }
          if (this.multipleSelection[0].bankAccountStatus == '002') {
            return this.tips('noForbid', 'error');
          }
          this.toPath('bankAccountEdit', { id: this.multipleSelection[0].id });
        } else if (value === 'forbid' || value === 'enable') {
          this.handleEnableOrForbid(value);
        } else if (value === 'export') {
          this.commonExport();
        } else if (value === 'import') {
          console.log('import');
          this.importLading();
        }
      },
      importLading() {
        this.$refs.siruiUpload.openDialog(true);
      },
      // 列表双击
      dblclickEvent(value) {
        this.toPath('bankAccountDetails', { id: value.row.id });
      },
      // 启用/禁用
      handleEnableOrForbid(type) {
        if (this.multipleSelection.length == 0) {
          return this.tips('noSelected', 'error');
        }
        let canOperItems = [];
        let flag = type == 'enable' ? '002' : '001';
        this.multipleSelection.forEach((item) => {
          if (item.bankAccountStatus == flag) {
            canOperItems.push(item);
          }
        });
        if (canOperItems.length == 0) {
          return this.tips(type == 'enable' ? 'cannotEnable' : 'cannotForbid', 'error');
        }
        let items = canOperItems.map((i) => i.id);
        let message = '';
        if (canOperItems.length !== this.multipleSelection.length) {
          message =
            type == 'enable'
              ? this.$t('bankAccountList.tips.hasCannotEnable')
              : this.$t('bankAccountList.tips.hasCannotForbid');
        }
        this.$confirmAction(
          type == 'enable' ? this.$t('confirm.liftContent') : this.$t('confirm.forbidContent'),
          message
        )
          .then(() => {
            const params = {
              bankAccountStatus: type == 'enable' ? '001' : '002',
              statusList: items,
            };
            this.$axios.post(API.UPDATE_BANKACCOUNT, params).then((res) => {
              if (res.data.code === 0) {
                this.$refs.siruiTable.clearSelectRecord();
                this.multipleSelection = [];
                this.getData();
                this.$message({ showClose: true, message: res.data.msg, type: 'success' });
              } else {
                this.$message({ showClose: true, message: res.data.msg, type: 'error' });
              }
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      // 提示
      tips(info, type) {
        this.$message({
          showClose: true,
          message: this.$t(`bankAccountList.tips.${info}`),
          type: type,
        });
      },
      // 跳转路径
      toPath(name, query) {
        let path = {
          path: `/bankAccount/${name}`,
          name: name,
          meta: {
            keepAlive: true,
          },
          query: query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>
